import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'


import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'MiniPagination',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  currentPage: {
    type: Number,
    required: true,
  },
  hasnext: {
    type: Boolean,
    required: true,
  },
},
  emits: ['current-change'],
  setup(__props, { emit }) {

const props = __props





const pageCount = computed(() => {
  if (props.hasnext) {
    return props.currentPage + 1
  } else {
    return props.currentPage
  }
})

const handleCurrentChanged = (page: number) => {
  emit('current-change', page)
}

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createBlock(_component_el_pagination, {
    background: "",
    layout: "prev, next",
    "current-page": __props.currentPage,
    "page-count": _unref(pageCount),
    onCurrentChange: handleCurrentChanged
  }, null, 8, ["current-page", "page-count"]))
}
}

})